// extracted by mini-css-extract-plugin
export default {"title":"j_lIAUJkHWPCcjy_7SC0"};